import React, { useState } from 'react';
import { Modal, Select, message } from 'antd';
import styles from './CompareModal.module.scss';

interface CompareModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: (selectedVersionId: number) => void;
  loading: boolean;
  fileDetail?: any;
  selectedVersion?: number;
}

const CompareModal: React.FC<CompareModalProps> = ({
  visible,
  onCancel,
  onConfirm,
  loading,
  fileDetail,
  selectedVersion
}) => {
  const [selectedVersionForCompare, setSelectedVersionForCompare] = useState<number | null>(null);

  // Get version options excluding current selected version
  const getVersionOptions = () => {
    if (!fileDetail?.versions) return [];
    
    // Find current selected version
    const currentSelectedVersion = fileDetail.versions.find((v: any) => v.id === selectedVersion)?.id;
    
    return fileDetail.versions
      .filter((version: any) => version.id !== currentSelectedVersion) // Exclude current selected version
      .map((version: any) => ({
        label: version.name || `Version ${version.id}`,
        value: version.id,
        disabled: false
      }));
  };

  const handleConfirm = () => {
    if (!selectedVersionForCompare) {
      message.error('Please select a version');
      return;
    }

    onConfirm(selectedVersionForCompare);
    setSelectedVersionForCompare(null);
  };

  const handleCancel = () => {
    onCancel();
    setSelectedVersionForCompare(null);
  };

  return (
    <Modal
      title="Compare with"
      open={visible}
      onCancel={handleCancel}
      onOk={handleConfirm}
      confirmLoading={loading}
      okText="Compare"
      cancelText="Cancel"
      width={600}
      className={styles.compareModal}
    >
      <div className={styles.content}>
        <div className={styles.versionSection}>
          <p className={styles.sectionTitle}>
            Versions
          </p>
          <Select
            className={styles.versionSelect}
            placeholder="Select a version"
            value={selectedVersionForCompare || undefined}
            onChange={setSelectedVersionForCompare}
            loading={false}
            options={getVersionOptions()}
          />
        </div>
        <p className={styles.helpText}>
          Please select a version to compare with the current version.
        </p>
      </div>
    </Modal>
  );
};

export default CompareModal; 